// app/javascript/landing/sections/Hero.tsx
import React from "react";
import { motion, Transition, Variants } from "framer-motion";
import { SmartImage } from "./../components/SmartImage";

const transition: Transition = {
  duration: 1,
  ease: [0.25, 0.1, 0.25, 1],
};

const itemVariants: Variants = {
  hidden: { filter: "blur(10px)", transform: "translateY(20%)", opacity: 0 },
  visible: { filter: "blur(0)", transform: "translateY(0)", opacity: 1 },
};

import type { RouteKey } from "../components/Navbar";

type HeroSectionProps = {
  onNavigate?: (route: RouteKey, href: string) => void;
};

export function Hero({ onNavigate }: HeroSectionProps) {
  return (
    <section
      id="inicio"
      className="relative overflow-hidden min-h-[clamp(560px,100dvh,880px)] bg-black flex items-end py-30"
    >
      {/* Fondo */}
      <SmartImage
        src="/landing/hero/hero-bg.png"
        fill
        wrapperClassName="absolute! inset-0"
      />

      {/* <div className="absolute inset-0">
        <img
          src="/landing/hero/hero-bg.png"
          alt=""
          className="h-full w-full object-cover"
          draggable={false}
        />
      </div> */}

      {/* Contenido */}
      <motion.div
        className="relative max-w-5xl xl:max-w-6xl w-full mx-auto px-4"
        initial="hidden"
        animate="visible"
        transition={{ staggerChildren: 0.12, delayChildren: 0.25 }}
      >
        <div className="max-w-2xl">
          {/* TÍTULO: usa headingVariants + itemVariants en cada línea */}
          <h1
            className="leading-tight text-white"
            // variants={headingVariants}
          >
            <motion.span
              className="block text-4xl md:text-5xl font-bold"
              transition={transition}
              variants={itemVariants}
            >
              METAVERSO
            </motion.span>

            <motion.span
              className="block text-xl md:text-2xl font-normal"
              transition={transition}
              variants={itemVariants}
            >
              DE LA
            </motion.span>

            <motion.span
              className="block text-4xl md:text-5xl font-bold"
              transition={transition}
              variants={itemVariants}
            >
              CONSTRUCCIÓN
            </motion.span>
          </h1>

          {/* PÁRRAFO */}
          <motion.p
            className="mt-5 text-xl md:text-2xl max-w-2xl text-white"
            transition={transition}
            variants={itemVariants}
          >
            Diseñamos experiencias inmersivas que conectan a la industria
            tradicional con las nuevas realidades digitales
          </motion.p>

          {/* BOTONES */}
          <div className="mt-12 md:mt-24 flex flex-wrap gap-6">
            <motion.div transition={transition} variants={itemVariants}>
              <a
                className="btn-landing"
                href="/contacto"
                onClick={(e) => {
                  if (onNavigate) {
                    e.preventDefault();
                    onNavigate("contacto", "/contacto");
                  }
                }}
              >
                Súmate
              </a>
            </motion.div>
            <motion.div transition={transition} variants={itemVariants}>
              <a className="btn-landing-white" href="/login">
                Iniciar sesión
              </a>
            </motion.div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
